module.exports = __webpack_public_path__ + "i18n/it.8b31f79c484d4933776b73ce89c303de.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/it.json
// module id = 1059
// module chunks = 60